<template>
    <div>
        <div class="d-flex align-items-center" v-if="!params.node.rowPinned">
            <div v-if="params.data.is_underpaid" class="overpaid mr-2">
                <div
                    v-b-tooltip.hover.right="{ container: 'vue-app', variant: currentIconStyles['variant'] }"
                    title="Balance Due"
                    style="border: 2px solid #c00"
                    class="reservation-status-marker"
                ></div>
            </div>
            <div v-else-if="params.data.is_overpaid" class="overpaid mr-2">
                <div
                    v-b-tooltip.hover.right="{ container: 'vue-app', variant: currentIconStyles['variant'] }"
                    title="Refund Due"
                    style="background: #090"
                    class="reservation-status-marker"
                ></div>
            </div>
            <span v-else></span>
            <div
                v-if="!params.data.underpaid && !params.data.is_overpaid"
                v-b-tooltip.hover.right="{ container: 'vue-app', variant: currentIconStyles['variant'] }"
                :title="iconTooltipTitle"
                :style="{ ...currentIconStyles }"
                class="reservation-status-marker mr-2"
            ></div>
        </div>
 
    </div>
</template>

<script>
import {
    getReservationStatusTitle,
    getReservationStatusIconStyle,
} from '../../../utils/reservation-state';
export default {
    data() {
        return {
            status: null,
        };
    },
    mounted() {
        this.status = this.params.data.status;
    },
    computed: {
        currentIconStyles() {
            return getReservationStatusIconStyle(this.status);
        },
        iconTooltipTitle() {
            return getReservationStatusTitle(this.status);
        },
    }
};
</script>

<style lang="scss" scoped>
.reservation-status-marker {
    border-radius: 50%;
    width: 15px;
    height: 15px;
}
.overpaid {
    border: 2px solid red;
}
</style>